module.exports = __webpack_public_path__ + "img/bos21.dc61af46.webp";